export const passport = {
  "passport.secretShopper.update": "passport.secretShopper.update",
} as const;
